import React from 'react';
import Routes from './routes';

import './assets/sass/critical.scss';
import './assets/sass/main.scss';

const App = (props) => <Routes />

export default App;
